

import React from "react";
import { Container, Row, Col } from 'react-bootstrap'
import VendorSideBar from "../../Components/Vendor/VendorSideBar";
import UserProfile from '../../Components/User/UserProfile';
import SideBar from "../../Components/Admin/SideBar";



const AdminProfilePage = () => {
    return (
        <div className="d-flex justify-content-start">
            <div>
                <SideBar />
            </div>
            <div style={{ flexGrow: 1, padding: "20px" }}>
                <UserProfile />
            </div>
        </div>
    )
}

export default AdminProfilePage

